var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtasksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8667 11.6667C16.0449 11.6667 17 10.7115 17 9.53333C17 8.35512 16.0449 7.39999 14.8667 7.39999C13.6885 7.39999 12.7333 8.35512 12.7333 9.53333C12.7333 10.7115 13.6885 11.6667 14.8667 11.6667Z",
    stroke: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8667 20.2C16.0449 20.2 17 19.2449 17 18.0667C17 16.8885 16.0449 15.9333 14.8667 15.9333C13.6885 15.9333 12.7333 16.8885 12.7333 18.0667C12.7333 19.2449 13.6885 20.2 14.8667 20.2Z",
    stroke: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13333 0.999996C1.95513 0.999996 1 1.95512 1 3.13333C1 4.31154 1.95513 5.26666 3.13333 5.26666C4.31154 5.26666 5.26667 4.31154 5.26667 3.13333C5.26667 1.95512 4.31154 0.999996 3.13333 0.999996Z",
    stroke: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13336 6.33333V13.8C3.13336 15.8113 3.13336 16.817 3.7582 17.4418C4.38304 18.0667 5.3887 18.0667 7.40003 18.0667H12.7334",
    stroke: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13336 5.26666C3.13336 7.27799 3.13336 8.28365 3.7582 8.90848C4.38304 9.53333 5.3887 9.53333 7.40003 9.53333H12.7334",
    stroke: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtasksIcon);
export default __webpack_public_path__ + "static/media/subtasks_icon.e9b59172b89552c76ce0b046e4dff2b8.svg";
export { ForwardRef as ReactComponent };